import { TemplateRef } from '@angular/core';
import { EjecutivoCementoVm } from '../../../models/ejecutivo-cemento.vm';
import { AdminServerTableCellContext, AdminServerTableColumn } from '../../../shared/table/models/admin-server-table.model';

export function buildEjecutivosCementoColumns(templates: {
  comunasCellTemplate: TemplateRef<AdminServerTableCellContext<EjecutivoCementoVm>>;
  actionsCellTemplate: TemplateRef<AdminServerTableCellContext<EjecutivoCementoVm>>;
}): AdminServerTableColumn<EjecutivoCementoVm>[] {
  return [
    { id: 'nombre', header: 'Nombre', sortable: true, sortKey: 'nombre', value: row => row.nombre },
    { id: 'correo', header: 'Correo', sortable: true, sortKey: 'correo', value: row => row.correo },
    { id: 'telefono', header: 'Teléfono', sortable: true, sortKey: 'telefono', value: row => row.telefono || '—' },
    { id: 'regionName', header: 'Región', sortable: true, sortKey: 'regionName', value: row => row.regionName },
    { id: 'comunas', header: 'Comunas', cellTemplate: templates.comunasCellTemplate },
    { id: 'activo', header: 'Estado', sortable: true, sortKey: 'activo', value: row => row.activo ? 'Activo' : 'Inactivo' },
    { id: 'acciones', header: 'Acciones', cellTemplate: templates.actionsCellTemplate, title: () => '' },
  ];
}
